import { createSlice } from '@reduxjs/toolkit';

import { mapApiSlice } from './apiSlice/map-api-slice';

const initialState = {
    sources: {},
    cities: [],
    productZones: {},
    homeProducts: {},
    propertyStatuses: {},
    projectStatuses: {},
};

export const mapSlice = createSlice({
    name: 'map',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            mapApiSlice.endpoints.getMapInitData.matchFulfilled,
            (state, action) => {
                const cities = action.payload?.valid_cities || [];
                cities.sort((a, b) => (a > b ? 1 : -1));
                state.cities = cities;
                state.propertyStatuses = action.payload?.valid_statuses || {};
                state.sources = action?.payload?.valid_sources || {};
                state.productZones = action?.payload?.valid_product_zones || {};
                state.homeProducts = action?.payload?.home_products || {};
                state.projectStatuses = action?.payload?.valid_project_statuses || {};
            }
        );
    },
});

export const selectCities = (state) => state.map.cities;
export const selectHomeProducts = (state) => state.map.homeProducts;
export const selectProductZones = (state) => state.map.productZones;
export const selectSources = (state) => state.map.sources;
export const selectPropertyStatuses = (state) => state.map.propertyStatuses;
export const selectProjectStatuses = (state) => state.map.projectStatuses;

export default mapSlice.reducer;
